export default __webpack_public_path__ + "static/media/menu.8e1368e7.gif";